import { useMemo } from "react";
import { requestStatus } from "../../../../../constants";
import { useSelector } from "../../../../../store/store";

interface IUseApprovalProcessData {
    "@odata.context": string;
    "@odata.etag": string;
    createdDateTime: string;
    eTag: string;
    id: string;
    lastModifiedDateTime: string;
    webUrl: string;

    createdBy: {
        user: {
            email: string;
            id: string;
            displayName: string;
        };
    };

    lastModifiedBy: {
        application?: {
            id: string;
            displayName: string;
        };
        user?: {
            email: string;
            id: string;
            displayName: string;
        };
    };

    parentReference: {
        id: string;
        siteId: string;
    };

    contentType: {
        id: string;
        name: string;
    };

    "fields@odata.context": string;

    fields: IUseApprovalProcessDataFields;
}

interface IUseApprovalProcessDataFields {
    "@odata.etag": string;

    Title: string;
    eBaseId: string;
    eStage: string;
    eSuggestion: string;
    ePurpose: string;
    eDeadline: string;
    eContent: string; // JSON string
    eFileContent: string; // JSON string
    eDeptHeadComment: string; // JSON string
    eApprovedBy: string;
    eApprovedDate: string;
    eApprovedByITLead: string;
    eAssignee: string;
    eRequestStatus: string;
    eRequestType: string;
    eSoftwareId: string;
    eDepartment: string;
    eUnit: string;
    ePhoneNumber: string;
    eApprovedStatus?: string;
    eApprovedByITLeadStatus?: string;
    eAssigneeStatus?: string;
}

interface IUseApprovalProcessStep {
    approver: string;
    status: string;
}

interface IUseApprovalProcessProps {
    steps: IUseApprovalProcessStep[]
    data: IUseApprovalProcessData
}

/**
 * step bắt đầu từ 0
 * @param props 
 */
const useApprovalProcess = (props: IUseApprovalProcessProps) => {
    const { steps, data } = props

    const user = useSelector((state: any) => state.user.current)
    const currentEmail = user?.username.toLowerCase()

    // Approved Rejected
    // eApprovedBy eApprovedStatus
    // eApprovedByITLead eApprovedByITLeadStatus
    // eAssignee eAssigneeStatus

    const currentStep = useMemo(() => steps.findIndex(step => !data.fields[step.status as keyof IUseApprovalProcessDataFields]), [data.fields, steps])

    const canApproval = useMemo(() => {
        if (currentStep === -1) return false
        const approvalEmail = data.fields[steps[currentStep].approver as keyof IUseApprovalProcessDataFields]
        const preStatus = currentStep === 0 ? requestStatus.submitted : data.fields[steps[currentStep - 1].status as keyof IUseApprovalProcessDataFields]

        if (approvalEmail?.toLowerCase().includes(currentEmail) && preStatus !== requestStatus.rejected) return true
        return false
    }, [currentEmail, currentStep, data.fields, steps])

    const canRecover = useMemo(() => {
        if (currentStep <= 0) return false;

        let index = currentStep - 1;

        if (currentStep === -1)
            index = steps.length - 1;

        const recoverEmail = data.fields[steps[index].approver as keyof IUseApprovalProcessDataFields]
        if (recoverEmail?.toLowerCase().includes(currentEmail)) return true
        return false
    }, [currentEmail, currentStep, data.fields, steps])

    return {
        currentStep,
        canApproval,
        canRecover
    }
}

export default useApprovalProcess